var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidthHeightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    width: 20.58,
    height: 13.675,
    viewBox: "0 0 20.58 13.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2222{fill:#6d6d70}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3944",
    d: "M20.056 0H2.808a.549.549 0 0 0-.4.166L.126 2.558A.447.447 0 0 0 0 2.865V13.2a.5.5 0 0 0 .524.473h19.532a.5.5 0 0 0 .524-.473V.473A.5.5 0 0 0 20.056 0zm-.524 12.729H1.048V3.04l2-2.095h16.484z",
    className: "cls-2222",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3945",
    d: "M2.72 5.156a.473.473 0 0 0 .473.473h1.716a.473.473 0 0 0 .473-.473V3.383a.473.473 0 0 0-.946 0v1.3H3.193a.473.473 0 0 0-.473.473z",
    className: "cls-2222",
    transform: "translate(-1.434 -1.534)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3946",
    d: "M6.9 13.258l2.875 1.92a.189.189 0 0 0 .3-.161v-1.594h1.579a.326.326 0 0 0 0-.653H10.1v-1.6a.189.189 0 0 0-.3-.161l-2.9 1.927a.194.194 0 0 0 0 .322z",
    className: "cls-2222",
    transform: "translate(-3.114 -5.787)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3947",
    d: "M21.886 13.423h1.579v1.594a.189.189 0 0 0 .3.161l2.875-1.92a.194.194 0 0 0 0-.322l-2.875-1.925a.189.189 0 0 0-.3.161v1.6h-1.579a.326.326 0 0 0 0 .653z",
    className: "cls-2222",
    transform: "translate(-9.844 -5.787)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidthHeightIcon);
export default __webpack_public_path__ + "static/media/WidthHeightIcon.135d30ef.svg";
export { ForwardRef as ReactComponent };